export const timeFilters = [
    {
      id:"",
      title: 'filters.time.any'
    },

    {
      id:'h',
      title: 'filters.time.hour'
    },

    {
      id:'d',
      title: 'filters.time.day'
    },

    {
      id: 'w',
      title: 'filters.time.week'
    },

    {
      id:'m',
      title: 'filters.time.month'
    },

    {
      id: 'y',
      title: 'filters.time.year'
    },
]

export const podcastsTimeFilters = [
    {
      id:"",
      title: 'filters.time.any'
    },

    {
      id:'d',
      title: 'filters.time.24_hours'
    },

    {
      id: 'w',
      title: 'filters.time.week'
    },

    {
      id:'m',
      title: 'filters.time.month'
    },

    {
      id: 'y',
      title: 'filters.time.year'
    },
]

export const durationFilters = [
    {
      id:"",
      title: 'filters.duration.any'
    },

    {
      id:'le4',
      title: 'filters.duration.lt_4_min'
    },

    {
      id:'gt4le20',
      title: 'filters.duration.gt_4_min_and_lt_20_min'
    },

    {
      id: 'gt20',
      title: 'filters.duration.gt_20_min'
    },
]

export const sortByFilters = [
    {
      id:"",
      title: 'sort.relevance'
    },
    {
      id:'pdt',
      title: "sort.publish_date"
    }
]
